import { useEffect, useState } from "react";
import { getCatalog, getNavigation } from "./data";
import type { Catalog, DocumentNavigationAssignment, NavigationAssignment } from "./types";

export function useData() {
  const [catalog, setCatalog] = useState<Catalog>();
  const [navigation, setNavigation] = useState<NavigationAssignment[]>();
  const [documentNavigation, setDocumentNavigation] = useState<DocumentNavigationAssignment[]>([]);
  const [error, setError] = useState("");
  useEffect(() => { Promise.all([getCatalog(), getNavigation()]).then(([c, n]) => { setCatalog(c); setNavigation(n.assignments); setDocumentNavigation(n.documentAssignments || []); }).catch((e: Error) => setError(e.message)); }, []);
  return { catalog, navigation, documentNavigation, error };
}
